/**
 * Update Add-On Product API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../axiosInstance';
import { AddOnProduct, UpdateAddOnProductRequest } from './types';

export const updateAddOnProduct = async (
  id: string,
  data: UpdateAddOnProductRequest
): Promise<AddOnProduct> => {
  const response = await axiosInstance.put<AddOnProduct>(`/api/add-on-products/${id}`, data);
  return response.data;
};
